import I18n from 'I18n';
import { fromJS, List, Set as ImmutableSet } from 'immutable';
export function getLanguageNameFromCode(langCode) {
  return I18n.text(`SharedI18nStrings.languageNames.${langCode}`);
}
const getRepeaterIdKey = arrItem => {
  return arrItem.uuid ? 'uuid' : 'name';
};
const updateLanguage = (keyPath, translationData, updatedLinks, langKey) => {
  const key = keyPath.slice(1);
  key.unshift(langKey);
  // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
  return translationData.setIn(key, new List(updatedLinks));
};
const getTranslationsFromRepeater = (repeaterArr, masterLanguageMap) => {
  const tranlsationUUIDMap = {};
  if (!repeaterArr.size) return tranlsationUUIDMap;
  const accessKey = getRepeaterIdKey(repeaterArr.get(0).toJS());
  repeaterArr.forEach(link => {
    const repeaterItemUuid = link.get(accessKey);
    if (link && masterLanguageMap[repeaterItemUuid] &&
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    !tranlsationUUIDMap[repeaterItemUuid]) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      tranlsationUUIDMap[repeaterItemUuid] = link;
    }
  });
  return tranlsationUUIDMap;
};

// This is handles the difference in naming rules between translation records and content records
export const getProperTranslationKeyPath = translationRecordKeyPath => {
  if (!translationRecordKeyPath.length) return translationRecordKeyPath;
  if (translationRecordKeyPath.length > 1 && translationRecordKeyPath[1] === 'socialNetworkUrls') {
    translationRecordKeyPath.splice(1, 1, 'socialNetworksUrls');
  }
  return translationRecordKeyPath;
};

// Uses the keys between the maps to determine the missing translations and fills them in
const getMissingTranslations = (masterLanguageMap, tertiaryLanguageMap, accessKey, isPrimary) => {
  // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
  const masterLangSet = new ImmutableSet(Object.keys(masterLanguageMap));
  // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
  const translationSet = new ImmutableSet(Object.keys(tertiaryLanguageMap));
  const missingTranslations = masterLangSet.subtract(translationSet);
  const newLangTranslationValue = [];

  // if the new value for translations are not same length we need to sync the translations
  if (missingTranslations.size) {
    missingTranslations.forEach(translation => {
      if (isPrimary) {
        newLangTranslationValue.push(fromJS(Object.assign({}, masterLanguageMap[translation], {
          [accessKey]: translation
        })));
      } else {
        newLangTranslationValue.push(fromJS(Object.assign({}, masterLanguageMap[translation], {
          [accessKey]: translation,
          url: ''
        })));
      }
    });
  }
  return Object.values(tertiaryLanguageMap).concat(newLangTranslationValue);
};

// onChange when the social media link type updates we need to update across translations
function syncSocialLinks(masterLanguageMap, sociaLinks) {
  return sociaLinks.map(link => {
    const masterLink = masterLanguageMap[link.get('uuid')];
    if (masterLink['networkType'] !== link.get('networkType')) link = link.set('networkType', masterLink['networkType']);
    return link;
  });
}

// Syncs up the links by uuid assumes both languages have arrays of equal length
export function syncLanguageLinkTranslations(translatedContent, {
  prevValue,
  value,
  keyPath
}) {
  let translationData = translatedContent;
  const ACCESS_KEY = prevValue.length ? getRepeaterIdKey(prevValue[0]) : getRepeaterIdKey(value[0]);
  const recordKeyPath = getProperTranslationKeyPath([...keyPath]);
  const uuidMap = {};
  value.forEach(item => {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    uuidMap[item.uuid] = item;
  });
  const [...languageKeys] = translatedContent.keys();
  languageKeys.forEach((langKey, index) => {
    const isPrimary = index === 0;
    const langContent = fromJS(translatedContent.get(langKey));
    const repeaterValue = langContent.getIn(recordKeyPath.slice(1));
    const tertiaryLanguageMap = getTranslationsFromRepeater(repeaterValue, uuidMap);

    // if the new value for translations are not same length we need to sync the translations
    let updatedLinks = getMissingTranslations(uuidMap, tertiaryLanguageMap, ACCESS_KEY, isPrimary,
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 4 arguments, but got 5.
    recordKeyPath[1]);
    if (recordKeyPath[1] === 'socialNetworksUrls') {
      updatedLinks = syncSocialLinks(uuidMap, updatedLinks);
    }
    const key = keyPath.slice(1);
    key.unshift(langKey);
    translationData = updateLanguage(recordKeyPath, translationData, updatedLinks, langKey);
  });
  return translationData;
}